import { FC, useState } from "react";
import { Box, Dialog, DialogTitle, DialogContent } from "@mui/material";
import GenericForm from "../../../organization/GenericForm";
import fields from "src/components/entities/account/common/ForgetPasswordList";
import { FormButtonType } from "src/types/genericFrom.types";
import { BaseDialogType } from "src/types/dialog.types";
// import { usePostApiForgetPasswordOTPMutation } from "src/app/services/api.generated";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ChangeUserPasswordDialog: FC<BaseDialogType> = ({
  open,
  handleClose,
}) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    email: "",
  });

  // const [callForgetPassword, { isLoading: forgetPasswordLoading }] =
  //   usePostApiForgetPasswordOTPMutation();

  const onSubmit = () => {
    // callForgetPassword({
    //   email: state.email,
    // })
    //   .unwrap()
    //   .then(() => {
    //     handleClose();
    //     toast.success("عملیات با موفقیت انجام شد");
    //     navigate("/forgetPassword");
    //   });
  };

  const buttons: FormButtonType[] = [
    {
      onClick: handleClose,
      text: "انصراف",
      variant: "outlined",
      color: "primary",
      checkRequiredField: false,
    },
    {
      onClick: onSubmit,
      text: "ارسال",
      variant: "contained",
      color: "primary",
      checkRequiredField: true,
      isLoading: false,
    },
  ];

  return (
    <Dialog maxWidth="md" open={open} onClose={() => handleClose()}>
      <DialogTitle>تغییر رمز عبور</DialogTitle>
      <DialogContent>
        <Box sx={{ paddingTop: 1 }}>
          <GenericForm
            state={state}
            setState={setState}
            fields={fields}
            buttons={buttons}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeUserPasswordDialog;
